import { FunctionComponent, ReactElement } from 'react';
import { Box, styled } from '@mui/material';
import AdminPanelPage, { AdminPanelPageProps } from '@/views/layouts/admin-panel/AdminPanelPage';

const EmptyContainer = styled(Box)({
	maxWidth: '800px',
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
});

const AdminPanelPageEmpty = styled(AdminPanelPage)({
	height: '100vh',
	position: 'relative',
});

const EmptyAdminPanelPage: FunctionComponent<AdminPanelPageProps> = ({
	children,
	...rest
}): ReactElement => (
	<AdminPanelPageEmpty {...rest}>
		<EmptyContainer>{children}</EmptyContainer>
	</AdminPanelPageEmpty>
);

export default EmptyAdminPanelPage;
